export default __webpack_public_path__ + "static/media/apartment-card-saved-icon-filled.ca2b187e.svg";